import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import noop from 'lodash/noop';
import { SortIndicator } from './SortIndicator';
import { ColumnFilter } from './ColumnFilter';
export function GridHeaders(props) {
    const { columns: columnsProp, columnFilters, sort, filterable: filterableGlobal, sortable: sortableGlobal, onSortChange, onColumnFilterChange } = props;
    const columns = columnsProp.filter((x)=>x.show !== false);
    const headers = columns.map((col)=>{
        const { id } = col;
        const currentSort = sort.find((x)=>x.column === id);
        const sortable = sortableGlobal && col.sortable !== false;
        const onSort = sortable ? onSortChange : noop;
        const headerProps = col.thProps || {};
        const classes = classnames(headerProps.className, {
            pointer: sortable
        });
        return /*#__PURE__*/ _jsx("th", {
            ...headerProps,
            className: classes,
            onClick: ()=>onSort(id),
            "data-testid": `GridHeader-${id}`,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "header-flex-container",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "header-content",
                        children: col.header
                    }),
                    sortable && /*#__PURE__*/ _jsx("div", {
                        className: "header-sort ms-3",
                        children: /*#__PURE__*/ _jsx(SortIndicator, {
                            direction: currentSort?.direction
                        })
                    })
                ]
            })
        }, `header_${id}`);
    });
    const headers2 = columns.map((col)=>{
        const { id } = col;
        const currentColumnFilter = columnFilters[id];
        const filterable = filterableGlobal && col.filterable !== false;
        return /*#__PURE__*/ _jsxs("th", {
            className: "text-nowrap",
            "data-testid": `GridHeaderFilter-${id}`,
            children: [
                filterable && col.filters && Array.isArray(col.filters) && /*#__PURE__*/ _jsx(ColumnFilter, {
                    isActive: Object.prototype.hasOwnProperty.call(columnFilters, id),
                    onChange: (filter, value)=>onColumnFilterChange(id, filter, value),
                    filters: col.filters,
                    initialType: currentColumnFilter && currentColumnFilter.type,
                    initialValue: currentColumnFilter && currentColumnFilter.value
                }),
                filterable && col.filters && !Array.isArray(col.filters) && /*#__PURE__*/ _jsx(col.filters.Filter, {
                    value: currentColumnFilter?.value || '',
                    onValueChange: (value)=>onColumnFilterChange(id, col.filters, value)
                })
            ]
        }, `header_filter_${id}`);
    });
    const containsColumnFilters = columns.some((x)=>filterableGlobal && x.filterable !== false && (Array.isArray(x.filters) ? (x.filters || []).length : !!x.filters));
    return /*#__PURE__*/ _jsxs("thead", {
        children: [
            /*#__PURE__*/ _jsx("tr", {
                children: headers
            }),
            containsColumnFilters && /*#__PURE__*/ _jsx("tr", {
                children: headers2
            })
        ]
    });
}
